__turbopack_context__.v({
  "badge": "audience-engine-diagram-module__NV2fha__badge",
  "connector": "audience-engine-diagram-module__NV2fha__connector",
  "diagram": "audience-engine-diagram-module__NV2fha__diagram",
  "illustration": "audience-engine-diagram-module__NV2fha__illustration",
  "outcomeIcon": "audience-engine-diagram-module__NV2fha__outcomeIcon",
  "outcomeLabel": "audience-engine-diagram-module__NV2fha__outcomeLabel",
  "outcomes": "audience-engine-diagram-module__NV2fha__outcomes",
  "returnLoop": "audience-engine-diagram-module__NV2fha__returnLoop",
  "stage": "audience-engine-diagram-module__NV2fha__stage",
  "stages": "audience-engine-diagram-module__NV2fha__stages",
});
